import Vue from "vue";

const resourceContract = {
  namespaced: true,
  mutations: {
    SET_ITEMS( state, payload ){ },
    UNSET_ITEMS( state, payload ){ },
    SET_LIST( state, payload ){ },
    CLEAR_LIST( state, payload ){ },
  },
  getters: {
    GET_ITEMS_BY_LIST: state => payload => {
      /* payload로 날아온 listName을 이용해서 state.lists를 조회 후, state.lists[ listName ].docs 를 받아오면 댐. */
    }
  },
  actions: {
    get({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/crm/contract.condition", { params: { "page": 1, "size": 100, "sort": "desc", "estimate_id": payload._id } } ).then( res => {
          return resolve( res );
        })
      })
    },
    getItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/www/contract", { params: { "page": 1, "size": 100, "search_customer_id": payload._id } } ).then( res => {

          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },

    getContractStatus({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/www/contract.status", { params: { "page": 1, "size": 100, "search_contract_ids": payload } } ).then( res => {
          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },


    getItem({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/www/contract/${payload._id}` ).then( res => {

          /* commit( "SET_ITEM", res.data ) */
          return resolve( res );
        }).catch( reject );
      });
    },
    getAuditItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/www/contract.endorsement", { params: { "search_customer_id" : payload._id } } ).then( res => {


          return resolve( res );
        })
      })
    },
    getAuditItem({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/www/contract.endorsement/${payload._id}`).then( res => {


          return resolve( res );
        })
      })
    },
    getAccidentItems({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + "/v1/www/contract.accident", { params: { "search_customer_id" : payload._id } } ).then( res => {


          return resolve( res );
        })
      })
    },
    getAccidentItem({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/www/contract.accident/${payload._id}`).then( res => {


          return resolve( res );
        })
      })
    },
    getAutoData({ state, rootState, commit, dispatch }, payload ){
      return new Promise( ( resolve, reject ) => {

        Vue.axios.get( rootState.config.hostName + `/v1/www/contract.accident.auto/${payload.auto_id}`).then( res => {


          return resolve( res );
        })
      })
    },
  }

};

export default resourceContract;
